import Base from 'app/views/base';

import tmpl from 'templates/carrier_type_filter';

export default Base.extend({
  compiledTemplate: tmpl,

  events: {
    'keyup input#carrier-type-name-filter': 'updateFilter',
  },

  initialize() {
    this.collection.nameFilter = '';
  },

  updateFilter(e) {
    e.preventDefault();
    const newFilter = this.$(e.currentTarget).val();
    if (newFilter !== this.collection.nameFilter) {
      this.collection.nameFilter = newFilter;
      this.collection.trigger('filtered');
    }
  },
});



// WEBPACK FOOTER //
// ./app/views/carrier_type_filter_view.js